import React, { Component } from "react";
import { connect } from "react-redux";
import { IStreamActionDispatches, mapStreamDispatchToProps } from "../../redux/actions/stream";
import { IStreamState, mapStreamStateToProps } from "../../redux/reducers/stream";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";

// this component loads streams and clears them from memory
// if you need to load any more user data and clear it, do it here with connectCustom and rename
class LoadStreams extends Component<IStreamActionDispatches & IStreamState & IAuthProps> {
	componentDidMount() {
		this.props.loadStreams(this.props.authContext);
	}

	render() {
		return null;
	}
}

export default withAuth(
	connect<IStreamState, IStreamActionDispatches>(mapStreamStateToProps, mapStreamDispatchToProps)(LoadStreams),
	true
);
